import { useTranslation } from "react-i18next";
import styled from "styled-components";
import hero1200 from "../img/hero-1200.jpg";
import hero2400 from "../img/hero-2400.jpg";
import image1x from "../img/hero-400.jpg";
import image2x from "../img/hero-800.jpg";
import { HERO_IMAGES } from "../utils/heroImages";
import { getSite } from "../utils/sites";

const HomeHeroWrap = styled.div`
  margin: ${({ theme }) => theme.space[4]} ${({ theme }) => theme.space[2]};
  position: relative;
`;

const HomeHero = () => {
  const { i18n } = useTranslation();
  const site = getSite();

  return (
    <>
      {HERO_IMAGES.map((locale) => {
        return (locale.site && site === locale.site) ||
          (!locale.site && i18n.language === locale.language) ? (
          <HomeHeroWrap key={locale.language + (locale.site || "")}>
            <picture>
              <source
                media="(min-width: 900px)"
                srcSet={`
                  ${hero1200} 1200w,
                  ${hero2400} 2400w
                `}
                sizes="(min-width: 1220px) 1180px, (min-width: 900px) calc(100vw - 40px), 100vw"
              />
              <img
                src={`${image1x}`}
                srcSet={`
                  ${image1x} 400w,
                  ${image2x} 800w
                  `}
                sizes="calc(100vw - 20px)"
                alt={locale.alt_text}
              />
            </picture>
          </HomeHeroWrap>
        ) : null;
      })}
    </>
  );
};

export default HomeHero;
